import { Capacitor } from '@capacitor/core';

// JS adapter for a future native Firebase phone auth Capacitor plugin.
// Must only be used on native platforms.

function getNativePlugin() {
  if (!Capacitor.isNativePlatform()) {
    throw new Error('Native phone auth plugin is only available on native platforms.');
  }

  const cap = window.Capacitor || window.capacitor;
  const plugins = cap?.Plugins || {};
  if (!cap) {
    console.error('[NativePhoneAuth] Capacitor bridge not found on window.');
  }
  const plugin =
    plugins.NativePhoneAuth ||
    plugins.NativeFirebasePhoneAuth ||
    window.NativePhoneAuth;

  if (!plugin) {
    console.error('[NativePhoneAuth] Plugin missing. Available plugins:', Object.keys(plugins));
    throw new Error('Native phone auth plugin not available. Ensure it is installed on Android/iOS.');
  }

  return plugin;
}

export async function startNativePhoneVerification(phoneNumber) {
  console.log('[NativePhoneAuth] startPhoneVerification', { hasNumber: !!phoneNumber });
  const plugin = getNativePlugin();
  const result = await plugin.startPhoneVerification({ phoneNumber });
  console.log('[NativePhoneAuth] startPhoneVerification result', result);
  return result;
}

export async function confirmNativePhoneCode(verificationId, code, nativeAuthToken, expectedUid) {
  console.log('[NativePhoneAuth] confirmPhoneCode', {
    hasVerificationId: !!verificationId,
    hasCode: !!code,
    hasNativeAuthToken: !!nativeAuthToken,
    hasExpectedUid: !!expectedUid,
  });
  const plugin = getNativePlugin();
  const result = await plugin.confirmPhoneCode({
    verificationId,
    code,
    nativeAuthToken,
    expectedUid,
  });
  console.log('[NativePhoneAuth] confirmPhoneCode result', result);
  return result;
}
